export enum Microservices {
  Authorization = 'Authorization/api',
  Chat = 'Chat/api',
  ClaimEntry = 'ClaimEntry/api',
  ClarityIdCard = 'IDCard/api',
  CoordinationOfBenefits = 'CoordinationOfBenefits/api',
  Documents = 'Documents/api',
  Invoices = 'Invoices/api',
  MemberPreferences = 'PreferenceCenter/api/Preferences',
  Provider = 'Provider/api',
  ProviderDirectory = 'ProviderDirectory/api',
  ProviderOnline = 'ProviderOnline/api',
  SecurityGroup = 'ProviderSecurity/api',
  SnapRenewalDates = 'GovernmentPrograms/api/snapRenewalDates',
  SpendingAccounts = 'SpendingAccounts/api/transactions',
  SpendingSummary = 'SpendingSummary/api/SpendingSummary',
  Subscriber = 'Subscriber/api',
  SubscriberProvider = 'SubscriberProvider/api',
  UmbracoCMS = 'UmbracoCMS/api',
}

export enum CoverageTypes {
  Medical = 'Medical',
  Dental = 'Dental',
  Vision = 'Vision',
  ValueAddedBenefits = 'Value Added Benefits',
  Pediatric = 'Pediatric'
}

export enum PlanStatus {
  Active = 1,
  FututeActive = 2,
  Termed = 3
}

export enum Status {
  Active = 'Active',
  Termed = 'Termed',
  Future = 'FutureActive'
}

export enum DocumentTypes {
  Benefits = 'benefits',
  SOB = 'sob',
  Policy = 'policy',
  COC = 'coc',
  ExternalDocument = 'externaldocument'
}

export enum ErrorCodes {
  LoginFailed = 1,
  NotFound = 404
}

export enum ELaunchDarklyFlag {
  ClinicalModule = 'release-clinical-module',
  HomepageModule = 'release-home-page',
  MarketingPillarModule = 'release-marketing-pillars',
  ReleaseRemoveNavinet = 'release-remove-navinet',
  SignUp = 'release-png-sign-up',
  SignIn = 'release-png-sign-in',
  ShowHomepageChat = 'show-homepage-chat',
  ShowUMTeamAvailable = 'show-um-team-available',
  ShowViewAuthorization = 'show-view-authorization',
  KillSwitchForceAppUpdate = 'kill-switch-force-app-update',
  ClaimsBillingModule = 'release-claims-module'
}
